import triggerTracking, {
    PageShowEvent
} from '@blueprint/tracking/dist/Tracking';
import { trackPage as trackSegmentPage } from './segment/trackPage';
import { Taxonomy } from './contracts';
import { getPageTrackingData } from './getPageTrackingData/getPageTrackingData';

type PageTrackingData = {
    ecommerce?: Record<string, unknown> | undefined;
    taxonomy: Record<string, unknown>;
};

export const trackPage = async (
    page: string,
    extraTaxonomy: Record<string, unknown> = {},
    extraEcommerce: Record<string, unknown> | null = null
): Promise<PageTrackingData> => {
    const pageTrackingData = await getPageTrackingData(
        page,
        extraTaxonomy,
        extraEcommerce
    );
    const pageShowEvent: PageShowEvent = {
        event: 'pageshow',
        ...pageTrackingData
    };

    triggerTracking(pageShowEvent);

    // unknown as a temporary way to reuse current taxonomy definition
    trackSegmentPage(pageTrackingData.taxonomy as unknown as Taxonomy);

    return pageTrackingData;
};
